"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("components/canvasEditor/constants");
const qr_code_png_1 = __importDefault(require("components/canvasEditor/text/assets/qr-code.png"));
class QrCodeHelper {
    static isQRCode(src = '') {
        return src === constants_1.CERTIFICATE_TAG.QR_CODE;
    }
}
_a = QrCodeHelper;
QrCodeHelper.replaceXMLQrCodeWithTag = (xml) => {
    const parsedXML = new window.DOMParser().parseFromString(xml, 'text/xml');
    let hasQRCode = false;
    Array.from(parsedXML.getElementsByTagName('image')).forEach((item) => {
        if (item.getAttribute('xlink:href') === qr_code_png_1.default) {
            hasQRCode = true;
            const svgElement = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            const foreignObjectElement = document.createElement('foreignObject');
            foreignObjectElement.append(constants_1.CERTIFICATE_TAG.QR_CODE);
            svgElement.append(foreignObjectElement);
            ['style', 'y', 'x', 'width', 'height'].forEach((attrName) => {
                svgElement.setAttribute(attrName, item.getAttribute(attrName) || '');
            });
            item.replaceWith(svgElement);
        }
    });
    return { xml: new XMLSerializer().serializeToString(parsedXML), hasQRCode };
};
QrCodeHelper.replaceJsonQrCodeWithTag = (templateJson) => {
    var _b;
    return {
        ...templateJson,
        objects: (_b = templateJson === null || templateJson === void 0 ? void 0 : templateJson.objects) === null || _b === void 0 ? void 0 : _b.map((item) => {
            return item.type === 'image' && item.src === qr_code_png_1.default
                ? {
                    ...item,
                    src: constants_1.CERTIFICATE_TAG.QR_CODE,
                    lockScalingY: true,
                    lockScalingX: true
                }
                : item;
        })
    };
};
QrCodeHelper.replaceCertificateQrCodeWithTag = (certificate) => {
    const templateJson = _a.replaceJsonQrCodeWithTag(certificate.templateJson);
    const { xml: templateSvg, hasQRCode } = _a.replaceXMLQrCodeWithTag(certificate.templateSvg);
    return {
        certificate: { ...certificate, templateJson, templateSvg },
        hasQRCode
    };
};
QrCodeHelper.replaceCertificateTagWithQRCode = (certificate) => {
    const templateJson = {
        ...certificate.templateJson,
        objects: certificate.templateJson.objects.map((item) => {
            return _a.isQRCode(item.src) ? { ...item, src: qr_code_png_1.default } : item;
        })
    };
    return { ...certificate, templateJson };
};
exports.default = QrCodeHelper;
